/**
 * report-builder-api
 * API сервиса генерации отчетов
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Тип представления UI-компонента или параметра, определяющий визуальное представление и формат данных (\'text\' | \'number\' | \'boolean\' | \'date\' |\'time\' | \'datetime\' | \'object\' | \'array\').
 */
export type ParameterType = 'text' | 'number' | 'boolean' | 'datetime' | 'date' | 'time' | 'array' | 'object';

export const ParameterType = {
    Text: 'text' as ParameterType,
    Number: 'number' as ParameterType,
    Boolean: 'boolean' as ParameterType,
    Datetime: 'datetime' as ParameterType,
    Date: 'date' as ParameterType,
    Time: 'time' as ParameterType,
    Array: 'array' as ParameterType,
    Object: 'object' as ParameterType
};

